/** Each parameter type and matching svg icon name. */
export enum ParamType {
  BoolParam = 'boolparam',
  DoubleParam = 'doubleparam',
  IntParam = 'intparam',
  LookupParam = 'lookupparam',
  MultiChoiceParam = 'multichoiceparam',
  StringParam = 'stringparam'
}